<template>
    <div>
        <span v-if="isLoading">Loading</span>
        <span v-else>{{ this.total | currency }}</span>
    </div>
</template>
<script>
import additionalExpApi from '@/api/additionalExpenseApi';

export default {
    props: {
        orderId: {
            type: Number,
            default: null
        },
        date: {
            type: String,
            default: null
        },
        courierInfoId: {
            type: Number,
            default: null
        },
        restaurantId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            isLoading: true,
            total: 0.0
        };
    },
    mounted() {
        this.fetchAdditionalExpense();
    },
    watch: {
        date: function(a, b) {
            if (a !== b) {
                this.fetchAdditionalExpense();
            }
        }
    },
    methods: {
        async fetchAdditionalExpense() {
            try {
                this.isLoading = true;
                this.total = 0.0;
                var params = new URLSearchParams();
                if (this.orderId) {
                    params.append('order_id', this.orderId);
                }
                if (this.date) {
                    params.append('date', this.date);
                }
                if (this.restaurantId) {
                    params.append('restaurant_id', this.restaurantId);
                }
                if (this.courierInfoId) {
                    params.append('courier_info_id', this.courierInfoId);
                }
                var k = await additionalExpApi.getTotalAdditionalExpenses(
                    params.toString()
                );
                if (k.data) {
                    if (k.data.total) {
                        this.total = k.data.total;
                    }
                }
                this.$emit('total-addl-expense', this.total);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>
